import QuickAccess from './QuickAccess.gql';

export default QuickAccess;
